import React from "react";
import { connect } from "react-redux";
import StoreUser from "../../../types/StoreUser";
import { Community } from "../../../types/Community";
import { MediaStudioProvider } from "./context/MediaStudioContext";
import MediaStudioShell from "./MediaStudioShell";

type Props = {
  user?: StoreUser;
  community?: Community;
};

const MediaStudioScreen = ({ user, community }: Props) => (
  <MediaStudioProvider user={user} community={community}>
    <MediaStudioShell />
  </MediaStudioProvider>
);

const mapStateToProps = (state: any) => ({
  user: state.storeUser,
  community: state.community,
});

export default connect(mapStateToProps)(MediaStudioScreen);
